import {Injectable} from '@angular/core';
import {moduloPerform} from '../../diccionarios/performValuesModulo';
import {CommonService} from 'src/app/shared/utils/common.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';


@Injectable({
  providedIn: 'root'
})
export class ReportePerformService {

  // params: any;
  diccionarioUrl: any;
  urlIoIndustrias: string;
  urlVdi: string;

  // urlDatosMaestros: string;

  constructor(private _commom: CommonService,
              private _util: UtilsService) {
    this.diccionarioUrl = moduloPerform.url.conciliacionBancaria;
    // this.urlDatosMaestros = this._util.getDatosMaestros();
    this.urlIoIndustrias = this._util.getUrlIoIndustrias();
    this.urlVdi = this._util.geturlVdi();
    // this.params = moduloConciliacionBan.url.parametros;
  }

  getAll() {
    return this._commom.peticionGetConHeader(this.urlIoIndustrias + this.diccionarioUrl.conciBancParam);
  }


  deteleParametros(inIdBanco: string, inIdEmpresa: string) {
    return this._commom.peticionDeleteConHeader(this.urlIoIndustrias + this.diccionarioUrl.conciBancParam + `?idBanco=${inIdBanco}&idEmpresa=${inIdEmpresa}`);
  }

  getSelectorArchivo(inIdEmpresa: string, inIdBanco: string) {
    return this._commom.peticionGetConHeader(this.urlIoIndustrias + this.diccionarioUrl.findFormato + `?idBanco=${inIdBanco}&idEmpresa=${inIdEmpresa}`);
  }

  procesarArchivoSap(inObjet: any) {
    return this._commom.peticionPostConHeader(this.urlIoIndustrias + this.diccionarioUrl.uploadDocSAP, inObjet);
  }

  procesarArchivoCuerpo(inObjet: any) {
    return this._commom.peticionPostConHeader(this.urlIoIndustrias + this.diccionarioUrl.uploadDoc, inObjet);
  }

  getCobrosPendientes(payload: any) {
    return this._commom.peticionGetConHeader(this.urlIoIndustrias + this.diccionarioUrl.autorizarCobros.getCobrosPendientes + `?fecha=${payload.date}&idBanco=${payload.idBanco}&nCuenta=${payload.bankAccount}&cliente=${payload.customer}&vendedor=${payload.seller}&agencia=${payload.agency}`);
  }

  cargarExtractoBancario(inObjet: any) {
    //return this._commom.peticionPostConHeader(this.urlFinanzas + this.diccionarioUrl.extractoBancario, inObjet);
    return this._commom.peticionPostConHeader(this.urlVdi + this.diccionarioUrl.extractoBancario, inObjet);
  }

  procesarCobro(payload: any) {
    //return this._commom.peticionGetConHeader(this.urlFinanzas + this.diccionarioUrl.getAllextractoBancario+`?fechaExtracto=${payload.date}`);
    //return this._commom.peticionPutConHeader(this.urlFinanzas + this.diccionarioUrl.autorizarCobros.procesarCobro, payload);
    return this._commom.peticionPutConHeader(this.urlVdi + this.diccionarioUrl.autorizarCobros.procesarCobro, payload);
  }

  rechazarCobro(payload: any) {
    return this._commom.peticionDeleteConHeader(this.urlVdi + this.diccionarioUrl.autorizarCobros.rechazarCobro + payload.cobro.cobroId + '/' + payload.pagoDetalle.pagConsecutivo);
  }

  getAllExtractoBancario(payload: any) {
    //return this._commom.peticionGetConHeader(this.urlFinanzas + this.diccionarioUrl.getAllextractoBancario+`?fechaExtracto=${payload.date}`);
    return this._commom.peticionGetConHeader(this.urlIoIndustrias + this.diccionarioUrl.getAllextractoBancario + `?fechaExtracto=${payload.fechaExtracto}&idBanco=${payload.idBanco}&idEmpresa=${payload.idEmpresa}&nCuenta=${payload.nCuenta}`);
  }
  
  getReporteGauss(){
    return this._commom.peticionGetConHeader(
      this.urlIoIndustrias + this.diccionarioUrl.reportePerform.generateReportGauss+'/11650/11639.79/30.2749978882946381');
  }

  getReportePareto(fechaInici:string, fechaFin:string,idLinea:string,tolerancia,tipo){
    return this._commom.peticionGetConHeader(
      this.urlIoIndustrias + this.diccionarioUrl.reportePerform.generateReportPareto+`?fechaIni=${fechaInici}&fechaFin=${fechaFin}&idLinea=${idLinea}&porcTol=${tolerancia}&type=${tipo}`);
  }

  getFindReceta(fechaInici:string, fechaFin:string,ean14:string,idLinea:string){
    let values =`?fechaIni=${fechaInici}&fechaFin=${fechaFin}`;
    if(ean14!== ""){
      values = values + `&ean14=${ean14}`;
    }
    if(idLinea!== ""){
      values = values + `&idLinea=${idLinea}`;
    }
    return this._commom.peticionGetConHeader(
      this.urlIoIndustrias + this.diccionarioUrl.reportePerform.findReceta 
      + values);
  }

  getFindCodigoEan(fechaInici:string, fechaFin:string,lote:string,estado:string,idLinea:string){
    let values =`?fechaIni=${fechaInici}&fechaFin=${fechaFin}`;
    if(lote!== ""){
      values = values + `&lote=${lote}`;
    }
    if(estado!== ""){
      values = values + `&estado=${estado}`;
    }
    if(idLinea!== ""){
      values = values + `&idLinea=${idLinea}`;
    }
    return this._commom.peticionGetConHeader(
      this.urlIoIndustrias + this.diccionarioUrl.reportePerform.findEan14 
      + values);
  }

  getFindCodigoLote(fechaInici:string, fechaFin:string,ean14:string,estado:string,idLinea:string){
    let values =`?fechaIni=${fechaInici}&fechaFin=${fechaFin}`;
    if(ean14!== ""){
      values = values + `&ean14=${ean14}`;
    }
    if(estado!== ""){
      values = values + `&estado=${estado}`;
    }
    if(idLinea!== ""){
      values = values + `&idLinea=${idLinea}`;
    }
    return this._commom.peticionGetConHeader(
      this.urlIoIndustrias + this.diccionarioUrl.reportePerform.findLote 
      + values);
  }

  getFindReport(fechaInici:string, fechaFin:string,ean14?:string,lote?:string,estado?:string){
    let values =`?fechaIni=${fechaInici}&fechaFin=${fechaFin}`;
    if(ean14!== ""){
      values = values + `&ean14=${ean14}`;
    }
    if(lote!== ""){
      values = values + `&lote=${lote}`;
    }
    if(estado!== ""){
      values = values + `&estado=${estado}`;
    }
    return this._commom.peticionGetConHeader(
      this.urlIoIndustrias + this.diccionarioUrl.reportePerform.generateReport 
      + values);
  }

  //DETALLES DE "desviacionEstandar", "distribucion", "ean14", "pesoBalanza", "pesoReferencia", "pesoSap", "promedio", "toleranciaMax", "toleranciaMin"
  // Ticket 26766 // Problemas en material por el ean. SE AGREGA ARGUMENTO DE MATERIAL
  getFindReportGauss(fechaInici:string, fechaFin:string, ean14:string, receta:string, lote:string, idLinea:string, tolerancia, pesoSap, material:string){
    let values =`?fechaIni=${fechaInici}&fechaFin=${fechaFin}`;
    if(ean14!== ""){
      values = values + `&ean14=${ean14}`;
    }
    if(receta!== ""){
      values = values + `&receta=${receta}`;
    }
    if(lote!== ""){
      values = values + `&lote=${lote}`;
    }
    if(idLinea!== ""){
      values = values + `&idLinea=${idLinea}`;
    }
    if(tolerancia!== ""){
      values = values + `&porcTol=${tolerancia}`;
    }else{
      values = values + `&porcTol=100`;
    }
    if(pesoSap!== ""){
      values = values + `&peso=${pesoSap}`;
    }
    if(material!== ""){
      values = values + `&material=${material}`;
    }

    return this._commom.peticionGetConHeader(
      this.urlIoIndustrias + this.diccionarioUrl.reportePerform.generateReportGaussFilter 
      + values);
  }
  //find-gauss-detail
  // Ticket 26766 // Problemas en material por el ean. SE AGREGA ARGUMENTO DE MATERIAL
  getFindReportGaussDetail(fechaInici:string, fechaFin:string,ean14:string,receta:string,lote:string,idLinea:string, material:string){
    let values =`?fechaIni=${fechaInici}&fechaFin=${fechaFin}`;
    if(ean14!== ""){
      values = values + `&ean14=${ean14}`;
    }
    if(receta!== ""){
      values = values + `&receta=${receta}`;
    }
    if(lote!== ""){
      values = values + `&lote=${lote}`;
    }
    if(idLinea!== ""){
      values = values + `&idLinea=${idLinea}`;
    }
    if(material !== ""){
      values = values + `&material=${material}`;
    }
    return this._commom.peticionGetConHeader(
      this.urlIoIndustrias + this.diccionarioUrl.reportePerform.generateReportGaussFilterDetail 
      + values);
  }

  getFindReportDetail(fechaInici:string, fechaFin:string,ean14?:string,lote?:string,estado?:string,linea?:string){
    let values =`?fechaIni=${fechaInici}&fechaFin=${fechaFin}`;
    if(ean14!== ""){
      values = values + `&ean14=${ean14}`;
    }
    if(lote!== ""){
      values = values + `&lote=${lote}`;
    }
    if(estado!== ""){
      values = values + `&estado=${estado}`;
    }
    if(linea!== ""){
      values = values + `&idLinea=${linea}`;
    }
    return this._commom.peticionGetConHeader(
      this.urlIoIndustrias + this.diccionarioUrl.reportePerform.generateReportDetail 
      + values);
  }

  getAllReportSended(){
    return this._commom.peticionGetConHeader(
      this.urlIoIndustrias + this.diccionarioUrl.reportePerform.generateReportSAP);
  }

  findAllReportSended(lote:string,idMaterial:string){
    let values ="";
    if(lote!== "" && idMaterial!=""){
      values =`/find?idMaterial=${idMaterial}&lote=${lote}`;
    }else if(lote!== ""){
      values =`/find?idMaterial=0&lote=${lote}`;
    }else if(idMaterial!=""){
      values =`/find?idMaterial=${idMaterial}&lote=0`;
    }
    return this._commom.peticionGetConHeader(
      this.urlIoIndustrias + this.diccionarioUrl.reportePerform.generateReportSAP+values);
  }

  findAllDetail(lote:string,idMaterial:string,estadoSap?:string){
    let values ="";
    if(estadoSap== "" || estadoSap==undefined){
      values =`/find-detail?idMaterial=${idMaterial}&lote=${lote}&estadoSap=-1`;
    }else {
      values =`/find-detail?idMaterial=${idMaterial}&lote=${lote}&estadoSap=${estadoSap}`;
    }
    return this._commom.peticionGetConHeader(
      this.urlIoIndustrias + this.diccionarioUrl.reportePerform.generateReportSAP+values);
  }

  // getBancoPorEmpresa(inIdEmpresa: string) {
  //     // http://172.25.4.31:8081/qrks/v1/dmaestros/api/services/banco/pkEmpresa/444
  //     return this._commom.peticionGetConHeader(this.urlDatosMaestros + this.diccionarioUrl.banco + inIdEmpresa);
  // }

  // getAllEmpresa() {
  //     return this._commom.peticionGetConHeader(this.urlDatosMaestros + this.diccionarioUrl.empresa);
  // }


  //revisar esta funcion
  obtenerDatos(inIdBanco: string, inIdEmpresa: string) {
    // return this._commom.peticionGetConHeader(this.urlFinanzas + this.diccionarioUrl.obtenerConci +
    //     this.params.idempresa + inIdEmpresa + this.params.idBanco + inIdBanco);
  }


  // getCuentaPorBanco(inIdEmpresa: string, inIdBanco: string) {
  //     return this._commom.peticionGetConHeader(this.urlDatosMaestros + this.diccionarioUrl.bancoCuenta + inIdEmpresa + '/' + inIdBanco);
  // }


}
